import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../services/userService";

// Async thunks for admin user operations
export const getAllUsers = createAsyncThunk(
  "allUsers/getAllUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await userService.getAllUsers();
      return response.users;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch users");
    }
  }
);

// Initial state
const initialState = {
  users: [],
  loading: false,
  error: null,
};

// All Users slice
const allUsersSlice = createSlice({
  name: "allUsers",
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrors } = allUsersSlice.actions;
export default allUsersSlice.reducer;

